import { Nullable } from 'common-types';
import { createStore } from 'store-utils';

const ConnectionsConfigureStore = createStore<ConnectionsConfigureStoreState>(
  {
    isLoadingSave: false,
    domain: '',
    clientId: '',
    clientSecret: '',
    useCommonEndpoint: true,
    isUpdatable: false,
    errorMessage: null,
  },
  'Connections Configure Store',
);

interface ConnectionsConfigureStoreState {
  isLoadingSave: boolean;
  domain: string;
  clientId: string;
  clientSecret: string;
  useCommonEndpoint: boolean;
  isUpdatable: boolean;
  errorMessage: Nullable<string>;
}

export default ConnectionsConfigureStore;
